export default __webpack_public_path__ + "static/media/cloud.57dbb10b.jpg";